<template>
    <div class="contacts-service">
        <div class="service-cards">
            <div class="card-item" v-for="item in contactsPage.service_cards">
                <strong>{{ item.name }}</strong>
                <p>{{ item.desc }}</p>
                <div class="bottom-info">
                    <a :href="'tel:' + item.phone">{{ item.phone }}</a>
                    <div class="time"><svgIcon name="time" class="icon-time"/><span>{{ item.time }}</span></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'contacts-service',
        components: {
            svgIcon,
        },
        metaInfo() {
            return {
                title: 'Надежный застройщик "DIAL GROUP" - Сервисные службы',
                meta: [
                    { name: 'description', content:  'Первичные квартиры комфорт-класса в Алмалинском районе от 24 000 000 тенге. В 10 минутах от MEGA Park. Готовые квартиры в ЖК бизнес-класса в золотом квадрате.'},
                ]
            };
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            contactsPage: 'loadContactsPage',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/contacts-page/contacts-service.scss';
    @import '@/styles/components/contacts-page/respond/contacts-service-respond.scss';
</style>